import { post } from '../libs/requestClient';

export const linkUserToCard = ({ user_id, nfc_id }) => post('/v1/nfc/link-user', { nfc_id, user_id })